import React from 'react';
import { LinkToAdminBlock } from 'components';
import { ROLES } from 'config/constants';
import { BUS_USER_IS_BLOCKED } from 'config/error-codes-dictionary';

export const getTextAlertAcceptLinkRequest = (userRole) => {
  switch (userRole) {
    case ROLES.PERSONNEL:
    case ROLES.PERSONNEL_INACTIVE:
      return {
        text: 'Personnel is successfully linked',
        body: 'The user is now a linked staff member of your organization and can access and use your organization account as part of the OneSource use.',
      };
    default:
      return {
        text: 'Organization is successfully linked.',
        body: 'You are now a linked staff member of this organization and can use additional organization profile.',
      };
  }
};

export const getTextAlertUnlink = (userRole) => {
  switch (userRole) {
    case ROLES.PERSONNEL:
      return {
        text: 'Personnel is successfully unlinked',
        body: 'Personnel is unlinked, is removed from your profile and is no longer able to access your organizations profile information or those of your connections.',
      };
    case ROLES.RESEARCH_SITE:
      return {
        text: 'Research site is successfully unlinked',
        body: 'Research site is successfully unlinked. Your organization profile is deleted and you are no longer able to access organization profile information.',
      };

    default:
      return {
        text: 'Sponsor is successfully unlinked',
        body: 'Sponsor is successfully unlinked. Your organization profile is deleted and you are no longer able to access organization profile information.',
      };
  }
};

export const getTextAlertErrorHandler = (errors, options) => {
  const { data: { jobTitles = [] } = {}, isPersonnel } = options;
  const isHasAnotherOrganizationPersonnel = errors.find(
    (item) => item.code === 'bus.personnel_has_another_organization',
  );
  const isHasAnotherOrganizationOrg = errors.find(
    (item) =>
      item.code ===
      'bus.organization_tries_to_link_with_personnel_who_already_linked_with_another_organization',
  );
  const isHasAssignedJobTitles = errors.find(
    (item) => item.code === 'bus.research_site_has_assigned_job_titles',
  );
  const isUserBlocked = errors.find(
    (item) => item.code === BUS_USER_IS_BLOCKED,
  );
  const reasonForBlockedUser = isUserBlocked && isUserBlocked?.message;

  if (isUserBlocked) {
    return {
      text: 'Your account is blocked',
      body: <LinkToAdminBlock reason={reasonForBlockedUser} />,
    };
  }

  if (isHasAnotherOrganizationPersonnel) {
    return {
      text: 'Ooops….something went wrong.',
      body: 'Your request has not been sent. You have already linked with another organization. You can unlink the organization and try to link this one again.',
    };
  }

  if (isHasAnotherOrganizationOrg) {
    return {
      text: 'Ooops….something went wrong.',
      body: 'Personnel has already linked to another organization. If you want to link Personnel, you should decline this linking request and create new one.',
    };
  }

  if (isHasAssignedJobTitles) {
    return {
      text: 'Ooops….something went wrong.',
      body: `Personnel with job title(s) ${jobTitles} has / have already linked to the location. If you want to link ${
        isPersonnel ? 'this Research site' : 'this Personnel'
      }, you should decline this linking request and create a new one with the correct set of job title(s).`,
    };
  }

  return {
    text: 'Ooops….something went wrong.',
    body: 'Your request is not sent. Please try again later.',
  };
};
